import { Select, Tabs } from "antd";
import Title from "antd/es/typography/Title";
import usePlanoDeGoverno from "./usePlanoDeGoverno";
import { useCallback } from "react";
import Loading from "../../components/Loading";
import TableEixo from "./components/TableEixo";
import TableAnexo from "./components/TableAnexo";
import { ModalFormAnexo } from "./components/Anexo/ModalFormAnexo";

export default function PlanoDeGoverno() {

    const {
        eixos,
        isLoading,
        refContagemDoFiltro,
        handleCreateOrEditEixo,
        onClickExcluirEixo,
        handleChangeCitySelected,
        onClickExcluirAnexo,
        handleCreateOrEditAnexo,
        cityOptionSelected,
        municipios,
        anexos,
        openModalAnexos,
        handleSaveAnexo,
        isEditarAnexo,
        anexoSelected,
        isLoadingEixos,
        isLoadingAnexos,
        isLoadingMunicipios,
        userCan,
    } = usePlanoDeGoverno();


    const tabEixos = useCallback(() => {
        return {
            label: 'Eixos',
            key: '0',
            children: <TableEixo
                eixos={eixos}
                handleCreateOrEditEixo={handleCreateOrEditEixo}
                onClickDelete={onClickExcluirEixo}
                refContagemDoFiltro={refContagemDoFiltro}
                isLoading={
                    isLoading ||
                    isLoadingEixos ||
                    isLoadingAnexos ||
                    isLoadingMunicipios
                }
            />

        }
    }, [eixos, isLoading,
        isLoadingEixos,
        isLoadingAnexos,
        isLoadingMunicipios,
    ]);


    const tabAnexos = useCallback(() => {
        return {
            label: 'Anexos',
            key: '1',
            children: <TableAnexo
                anexos={anexos}
                handleCreateOrEditAnexo={handleCreateOrEditAnexo}
                onClickDelete={onClickExcluirAnexo}
                refContagemDoFiltro={refContagemDoFiltro}
                isLoading={
                    isLoading ||
                    isLoadingEixos ||
                    isLoadingAnexos ||
                    isLoadingMunicipios
                }
            />
        }
    }, [anexos, isLoading,
        isLoadingEixos,
        isLoadingAnexos,
        isLoadingMunicipios,
    ]);


    if (!userCan('manage_government_plan')) {
        return (
            <>
                <Title level={3}>Você não tem permissão para acessar essa página.</Title>
            </>
        );
    }

    return (
        <Loading loading={
            isLoading ||
            isLoadingEixos ||
            isLoadingAnexos ||
            isLoadingMunicipios
        }>
            <>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    gap: 10,
                    flexWrap: 'wrap'
                    // alignItems: "center"
                }}>
                    <Title level={3}>Plano de Governo </Title>
                    <Select placeholder="Selecione uma cidade"
                        showSearch
                        value={cityOptionSelected}
                        onChange={handleChangeCitySelected}
                        loading={isLoadingMunicipios}
                        style={{
                            // width: '15%',
                            maxWidth: 300
                        }}>
                        {municipios?.map((municipio, index) => (
                            <Select.Option key={index} value={`${municipio.nome}-${municipio.idIbge}`}>{municipio.nome} - {municipio.estado}</Select.Option>
                        ))}
                    </Select>
                </div>

                {cityOptionSelected &&
                    <>
                        <Tabs
                            defaultActiveKey="0"
                            onTabClick={(activeKey) => {
                            }}
                            type="card"
                            tabBarStyle={{
                                marginTop: 10
                            }}
                            items={[tabEixos(), tabAnexos()]}
                        />
                    </>}
            </>
            <ModalFormAnexo
                isModalOpen={openModalAnexos}
                handleCancel={handleCreateOrEditAnexo}
                handleSave={handleSaveAnexo}
                loadingPage={
                    isLoading ||
                    isLoadingEixos ||
                    isLoadingAnexos ||
                    isLoadingMunicipios
                }
                isEditarAnexo={isEditarAnexo}
                anexoSelected={anexoSelected}
                key={1}
            />
        </Loading>
    );
}
